import { render } from "./CashbackPage.vue?vue&type=template&id=a25056aa&scoped=true"
import script from "./CashbackPage.vue?vue&type=script&lang=js"
export * from "./CashbackPage.vue?vue&type=script&lang=js"

import "./CashbackPage.vue?vue&type=style&index=0&id=a25056aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a25056aa"]])

export default __exports__